import axios from 'axios';

export const apiConst = {
  INIT: 'init',
  LOGIN: 'login',
  SAVE: 'save',
  SAVE_EXCEL: 'save_excel',
  GET_EXCEL: 'get_excel',
  GET: 'get',
  SAVE_IMAGE: 'save_image',
  MAIL: 'mail',
  SAVE_MULTIPLE_IMAGES: 'save_multiple_images'
}

// if working locally, uncomment next line
const API_PATH = 'api/index.php';
// else
//const API_PATH = window.location.pathname + 'api/index.php';


export function api (type, obj = {}, callback = () => {console.log('api: empty callback')}) {

  const config = {
    onUploadProgress: function(progressEvent) {
      var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      console.log(percentCompleted)
    }
  }

  let snUID = window.localStorage.getItem('snUID');
  console.log('api snUID: ', snUID);
  console.log('API obj being sent :', obj);

  axios({
    method: 'post',
    url: `${API_PATH}`,
    headers: { 'content-type': 'application/json' },
    data: {type, obj, snUID: snUID ? snUID : '', token: window.localStorage.getItem('jwtToken')},
    onUploadProgress: function(progressEvent) {
      console.log('rpg', progressEvent);
      var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      console.log(percentCompleted)
    }
  })
  .then(result => {
    console.log('then')
    console.log('bare res: ', result);
    console.log(type, 'Backend\'s response\'s data :', result.data);
    //let parsedResult = JSON.parse(result.data);
    //console.log(type, ' Backend\'s response\'s data :', parsedResult);
    callback(result.data);
  })
  .catch(error => console.log( 'error: ', error ));
}